<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
    <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
      @if (status) {
        <span><i class="fas fa-angle-right"></i></span>
      }

      @if (!status) {
        <span><i class="fas fa-angle-left"></i></span>
      }
    </div>
    <div class="sidebar-header">
      <h3>{{'NavMenu.BusinessOwners'|translate}}</h3>
    </div>

    <ul class="list-unstyled components">
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.BusiPropStatementFiling'|translate}}" routerLink="business-prop-statement-filing">{{'NavMenu.BusiPropStatementFiling'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.BusinessPropAssessment'|translate}}" routerLink="business-prop-assessments">{{'NavMenu.BusinessPropAssessment'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.ImportantDatesBusinessOwners'|translate}}" routerLink="important-dates">{{'NavMenu.ImportantDatesBusinessOwners'|translate}}</a>
      </li>

      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.MobileHomes'|translate}}" routerLink="manufactured-homes">{{'NavMenu.MobileHomes'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.MarineAircraft'|translate}}" routerLink="marine-aircraft">{{'NavMenu.MarineAircraft'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.TrendFactors'|translate}}" routerLink="trends">{{'NavMenu.TrendFactors'|translate}}</a>
      </li>


    </ul>

  </nav>
  <div id="content">

    <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
    <i class="fas fa-align-left"></i>
    <span>Toggle Sidebar</span>
  </button> -->
  <router-outlet></router-outlet>
</div>


</div>
